
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Screen2 from './pages/Screen2';
import Notes from './pages/Notes';
import Calendar from './pages/Calendar';
import BottomNavigation from './components/BottomNavigation';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background pb-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/screen2" element={<Screen2 />} />
          <Route path="/screen3" element={<Notes />} />
          <Route path="/calendar" element={<Calendar />} />
        </Routes>
        <BottomNavigation />
      </div>
    </Router>
  );
}

export default App;
